import { DEFAULT_TIMEZONE } from '@constants/datetime';
import { RESALE_SETTINGS_FULLY_VISIBLE } from '@domain/resale-settings';

import { CompanyClubContextValue } from './company-club.type';

export const companyClubEmptyState = {
  companyClubState: {
    id: '',
    legacyId: '',
    isSiaeImportLimited: false,
  },
  companyState: {
    id: '',
    legacyId: '',
    name: '',
    commercialName: '',
    defaultChannel: {
      id: '',
      name: '',
      slug: '',
    },
    logoUrl: '',
  },
  clubState: {
    id: '',
    legacyId: '',
    coverUrl: '',
    logoUrl: '',
    name: '',
    slug: '',
    coordinates: {
      latitude: 0,
      longitude: 0,
    },
    city: {
      country: {
        id: '',
        name: '',
        isoCode: '',
        currency: '',
      },
      id: '',
      legacyId: '0',
      coverUrl: '',
      name: '',
      slug: '',
      timezone: '',
    },
  },
};

export const defaultCompanyClubContextState: CompanyClubContextValue = {
  isLoadingCompanyClub: false,
  venueAccess: { isRevoked: false, venueName: 'Xceed Test Venue' },
  companyClubState: {
    id: '276b5ad0-cf45-11eb-ab85-064aae1f9a87',
    legacyId: '7418',
    isSiaeImportLimited: false,
  },
  setCompanyClubState: () => {},
  companyState: {
    id: 'a2294bae-ae4e-11eb-affd-0ac1b97f4b58',
    legacyId: '5710',
    name: 'Xceed Test Venue',
    commercialName: 'Xceed Test Venue',
    logoUrl: 'https://images.xceed.me/companies/logos/company-a2294bae-ae4e-11eb-affd-0ac1b97f4b58-xceed-logo-40f3.png',
    defaultChannel: {
      id: 'e5ef4900-5426-11ec-935a-0ac1b97f4b58',
      name: 'Balco',
      slug: 'balco-2',
    },
    role: 'ADMIN',
  },
  setCompanyState: () => {},
  clubState: {
    id: '7ce77379-919c-11e9-846c-06b12363b88e',
    legacyId: '491',
    name: 'Test Venue',
    slug: 'test-venue',
    coverUrl: 'https://images.xceed.me/clubs/covers/test-venue-club-01test-city-xceed-55e5.png',
    logoUrl: 'https://images.xceed.me/clubs/logos/test-cardedeu-club-01test-city-xceed-logo.png',
    coordinates: {
      latitude: 34.245583866378,
      longitude: -77.93918766059,
    },
    city: {
      id: '066b85d9-1035-11ea-b000-06b880e08c2c',
      legacyId: '66',
      name: '01Test City',
      slug: '01test-city',
      coverUrl: 'https://images.xceed.me/cities/covers/01test-city-events-xceed-4ea4.png',
      timezone: DEFAULT_TIMEZONE,
      country: {
        id: '0a75d5ef-1035-11ea-b000-06b880e08c2c',
        name: 'Spain',
        isoCode: 'ESP',
        currency: 'EUR',
      },
    },
  },
  setClubState: () => {},
  setEmptyCompanyClubState: () => {},
  isTestVenueCompany: false,
  isExternalPlatformEnabledForCompany: false,
  isFloorplanV2Active: false,
  isExtraGuestsForBottleServiceActive: false,
  isAdmissionImageGalleryActive: false,
  isAddonImageGalleryActive: false,
  isAdmissionIncludeDrinksActive: false,
  isAddonTermsAndConditionsLinkActive: false,
  isWidgetSignInEnabled: false,
  isWidgetResaleActive: false,
  isWidgetEmbedGeneratorActive: false,
  isSecretLocationActive: false,
  isOrganizerPublicProfileActive: false,
  isDelayedDeliveryActive: false,
  isResaleSettingsActive: false,
  isTicketAlertsSettingsActive: false,
  resaleSettingsVisibility: RESALE_SETTINGS_FULLY_VISIBLE,
  isEventReportResaleActive: false,
  isEventReportSalesPaceActive: false,
  isEventReportTicketAlertsActive: false,
  isAddOrganizerToVenueActive: false,
  isAddOrganizerToVenueLoading: false,
  isVideoCoverUploadActive: false,
};
